// extracted by mini-css-extract-plugin
export default {"wrapper":"Blockquote_wrapper__s9gm6","blockquote":"Blockquote_blockquote__7ZoL5"};